import { FILE_AUTO_DELETE_VALUES } from '../constants/fileAutoDelete';

export const getTelefonoFromSession = () => {
    return sessionStorage.getItem('Telefono') || '';
};

export const getFileAutoDeleteFromSession = () => {
    const val = sessionStorage.getItem('FileAutoDelete');
    return val && Object.values(FILE_AUTO_DELETE_VALUES).includes(val)
        ? val
        : null;
};

export const getIDFromSession = () => {
    return sessionStorage.getItem('ID') ?? null;
};

export const getTwoAuthenticateFromSession = () => {
    return sessionStorage.getItem('TwoAuthenticate');
};

export const isTwoAuthenticateEnabled = () => {
    return getTwoAuthenticateFromSession() === '1';
};

export const getPrivacyPolicyFromSession = () => {
    return !sessionStorage.getItem('privacyPolicy').includes('0', 'null');
};

export const getNotificheAbilitateFromSession = () => {
    return sessionStorage.getItem('NotificheAbilitate') || 1;
};
